module.exports = __webpack_public_path__ + "img/index.646c067f.png";